import { PortalProductsSubscriptionsService } from './portal-products-subscriptions.service';
import { LoggingService } from '../../shared/services/core/logging.service';
import { Injectable } from '@angular/core';

/**
 * This resolver will handle the call
 * to fetch the subscribed portal products
 * of the current member.
 */

@Injectable({ providedIn: 'root' })
export class PortalProductsSubscriptionsResolver {
  constructor(
    private portalProductsSubscriptionsService: PortalProductsSubscriptionsService,
    private logService: LoggingService
  ) {}

  /**
   * Call to subscribed products service
   * to fetch all purchased portal products.
   */
  resolve() {
    this.logService.info('resolving portal subscriptions');
    return this.portalProductsSubscriptionsService.fetchSubscriptions();
  }
}
